// Utilitário único de máscara e validação de CNPJ.
// A partir de 2026 a Receita Federal aceita CNPJ alfanumérico: as 12
// primeiras posições podem ser letras (A-Z) ou números, os 2 dígitos
// verificadores (posições 13-14) continuam sempre numéricos.
const CNPJ_LENGTH = 14;
const CNPJ_BASE_LENGTH = 12;

export const cleanCnpj = (value: string): string =>
    (value ?? "").toString().replace(/[^0-9A-Za-z]/g, "").toUpperCase();

export const maskCnpj = (value: string): string => {
    let v = cleanCnpj(value).slice(0, CNPJ_LENGTH);

    v = v.replace(/^([0-9A-Z]{2})([0-9A-Z])/, "$1.$2");
    v = v.replace(/^([0-9A-Z]{2})\.([0-9A-Z]{3})([0-9A-Z])/, "$1.$2.$3");
    v = v.replace(/\.([0-9A-Z]{3})([0-9A-Z])/, ".$1/$2");
    v = v.replace(/([0-9A-Z]{4})([0-9]{1,2})$/, "$1-$2");

    return v;
};

// Nome mantido por compatibilidade com o restante do projeto (formatação de exibição).
export const formatarCNPJ = maskCnpj;

// Valor numérico de cada caractere para o cálculo do dígito verificador:
// '0'-'9' -> 0-9, 'A'-'Z' -> 17-42 (charCode - 48), conforme especificação da Receita Federal.
const charValue = (char: string): number => char.charCodeAt(0) - 48;

const calcCnpjCheckDigit = (base: string): number => {
    let sum = 0;
    let pos = base.length - 7;

    for (let i = base.length; i >= 1; i--) {
        sum += charValue(base.charAt(base.length - i)) * pos--;
        if (pos < 2) pos = 9;
    }

    const rest = sum % 11;
    return rest < 2 ? 0 : 11 - rest;
};

export const isValidCnpj = (value: string): boolean => {
    const clean = cleanCnpj(value);

    if (clean.length !== CNPJ_LENGTH) return false;
    if (/^(.)\1+$/.test(clean)) return false; // todos os caracteres iguais

    const digits = clean.slice(CNPJ_BASE_LENGTH);
    if (!/^[0-9]{2}$/.test(digits)) return false; // dígitos verificadores são sempre numéricos

    const dv1 = calcCnpjCheckDigit(clean.slice(0, 12));
    if (dv1 !== Number(digits[0])) return false;

    const dv2 = calcCnpjCheckDigit(clean.slice(0, 13));
    if (dv2 !== Number(digits[1])) return false;

    return true;
};
